import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer, FHSkeletonLoader } from '../../../../components/base';
import { FORTA_BLUE, FORTA_GRAY4 } from '../../../../utils/colors';
import { formatPhoneNum } from '../../../../utils/common';
import EmailIcon from '../../../../assets/images/email.svg';
import PhoneIcon from '../../../../assets/images/phone.svg';
import TimezoneIcon from '../../../../assets/images/timezone.svg';
import { DASHBOARD_SECTION_CONTENT_SX, DASHBOARD_SECTION_SX } from '../styles';
import { RelationshipManagerRow } from './components';
import { PHONE_NUMBER_LENGTH, RELATIONSHIP_MANAGER_TIME_ZONE_LABEL_KEYS } from './constants';
import { useRelationshipManager } from './hooks';
import { RELATIONSHIP_MANAGER_CARD_SX } from './styles';

function RelationshipManager() {
  const { t } = useTranslation('dashboard');
  const { loading, relationshipManager } = useRelationshipManager();

  if (loading) return <FHSkeletonLoader sx={{ mt: 3 }} />;
  if (!relationshipManager) return null;

  const timeZoneLabelKey = Object.entries(RELATIONSHIP_MANAGER_TIME_ZONE_LABEL_KEYS).find(
    ([timeZone]) => timeZone === relationshipManager.time_zone,
  )?.[1];

  return (
    <FBoxContainer
      dataTestId="relationshipManagerSection"
      sx={DASHBOARD_SECTION_SX}
      contentStyle={DASHBOARD_SECTION_CONTENT_SX}
    >
      <Typography fontSize={21} textAlign="left" mb={2} color={FORTA_BLUE.primary}>
        {t('sections.relationshipManager')}
      </Typography>
      <Box sx={RELATIONSHIP_MANAGER_CARD_SX}>
        <Typography fontSize={16} lineHeight={1.5} color={FORTA_GRAY4}>
          {`${relationshipManager.first_name} ${relationshipManager.last_name}`}
        </Typography>
        {timeZoneLabelKey && (
          <RelationshipManagerRow
            icon={TimezoneIcon}
            iconWidth={13}
            iconHeight={13}
            label={t('relationshipManager.timeZone', { timeZone: t(timeZoneLabelKey) })}
          />
        )}
        {relationshipManager.phone?.length === PHONE_NUMBER_LENGTH && (
          <RelationshipManagerRow
            icon={PhoneIcon}
            iconWidth={9}
            iconHeight={18.75}
            label={t('relationshipManager.phone', {
              phone: formatPhoneNum(relationshipManager.phone),
            })}
          />
        )}
        <RelationshipManagerRow
          icon={EmailIcon}
          iconWidth={20}
          iconHeight={9}
          label={t('relationshipManager.email', { email: relationshipManager.email })}
        />
      </Box>
    </FBoxContainer>
  );
}

export default RelationshipManager;
